import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useMemo, useState } from 'react';
export var CarouselCommonContext = /*#__PURE__*/React.createContext({
  swiperInstance: undefined,
  setSwiperInstance: function setSwiperInstance() {},
  loop: false
});
export var CarouselCommonProvider = function CarouselCommonProvider(_ref) {
  var children = _ref.children,
    loop = _ref.loop;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    swiperInstance = _useState2[0],
    setSwiperInstance = _useState2[1];
  var value = useMemo(function () {
    return {
      swiperInstance: swiperInstance,
      setSwiperInstance: setSwiperInstance,
      loop: loop
    };
  }, [swiperInstance, loop]);
  return /*#__PURE__*/React.createElement(CarouselCommonContext.Provider, {
    value: value
  }, children);
};
export var useCarouselCommonContext = function useCarouselCommonContext() {
  return useContext(CarouselCommonContext);
};